<template>
  <div>
    <template v-if="isUserDataLoaded && !isLoggingOut">
      <brand-navigation-bar v-if="cachedUserRole === 'BRAND' && !forceRetailerView" :top-offset="topOffset" />
      <retailer-navigation-bar v-else :display="!showNynow" />
    </template>
    <!-- Optionally show a skeleton loader or nothing while waiting for user data -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import BrandNavigationBar from './BrandNavigationBar.vue'
import RetailerNavigationBar from './RetailerNavigationBar.vue'
import session from '@/services/session'

export default {
  components: {
    BrandNavigationBar,
    RetailerNavigationBar
  },
  props: {
    forceRetailerView: {
      type: Boolean,
      default: false
    },
    showNynow: {
      type: Boolean,
      default: false
    },
    topOffset: {
      type: String,
      default: '0px'
    }
  },
  data() {
    return {
      isUserDataLoaded: false,
      initialRender: true,
      cachedUserRole: null,
      isLoggingOut: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'userState'
    })
  },
  watch: {
    user: {
      immediate: true,
      handler(newValue, oldValue) {
        // If we had a user before and now we don't, we're logging out
        if (oldValue && !newValue) {
          this.$logger.logAction('User changed to null, handling logout')
          this.handleLogout()
        } else if (newValue && newValue.role) {
          this.$logger.logAction('User data loaded in watcher', {
            userRole: newValue.role
          })
          this.cachedUserRole = newValue.role
          this.isUserDataLoaded = true
          this.isLoggingOut = false
        }
      }
    }
  },
  created() {
    // Try to get user role from session service first, which is faster than waiting for Vuex
    try {
      const role = session.getRole()
      if (role) {
        this.$logger.logAction('User role found in session service', { role })
        this.cachedUserRole = role
        this.isUserDataLoaded = true
        return
      }
    } catch (error) {
      console.error('Error checking session service for user role', error)
    }

    // Fallback to localStorage if session service fails
    try {
      const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
      if (userInfo && userInfo.role) {
        this.$logger.logAction('User role found in localStorage', {
          userRole: userInfo.role
        })
        this.cachedUserRole = userInfo.role
        this.isUserDataLoaded = true
        return
      }
    } catch (error) {
      console.error('Error checking localStorage for user data', error)
    }

    // Listen for logout events from eventBus
    this.$eventBus.$on('logout-initiated', this.handleLogout)

    // Set a timeout to avoid long waiting if something goes wrong with user data loading
    setTimeout(() => {
      if (!this.isUserDataLoaded) {
        this.$logger.logAction('Timeout reached, forcing navigation bar render with default (non-BRAND) behavior')
        this.isUserDataLoaded = true
      }
    }, 300)
  },
  mounted() {
    this.$logger.logAction('TheSecondaryHeader mounted', {
      cachedUserRole: this.cachedUserRole,
      userFromVuex: this.user?.role,
      forceRetailerView: this.forceRetailerView
    })
  },
  beforeDestroy() {
    // Clean up event listener
    this.$eventBus.$off('logout-initiated', this.handleLogout)
  },
  methods: {
    handleLogout() {
      this.$logger.logAction('Handling logout in TheSecondaryHeader')

      // Set all state to trigger component unmount
      this.isUserDataLoaded = false
      this.isLoggingOut = true

      // Force Vue to update the DOM
      this.$forceUpdate()

      // Use window.setTimeout with explicit binding to preserve component context
      window.setTimeout(
        function () {
          this.cachedUserRole = 'VISITOR'
          this.isLoggingOut = false
          this.isUserDataLoaded = true
          this.$logger.logAction('Component re-rendered as VISITOR')
        }.bind(this),
        100
      )
    }
  }
}
</script>